module.exports = __webpack_public_path__ + "img/export.73e43b60.svg";